var map = {
	"./AddCompliance.graphql": "e47f",
	"./AddEmployeeToBonusOrDeductionV3.graphql": "871b",
	"./AddEmployeesToRole.graphql": "29a6",
	"./AddEmployeesWithExcelLite.graphql": "726f",
	"./AddGratuityCompliance.graphql": "38ba",
	"./AddItfCompliance.graphql": "3fbb",
	"./AddManyEmployeesToBonusOrDeductionV3.graphql": "0f30",
	"./AddNewProduct.graphql": "b38a",
	"./AddNhfCompliance.graphql": "a6c1",
	"./AddPensionCompliance.graphql": "1c8e",
	"./AddSalariesAndProrate.graphql": "bed5",
	"./AddSalary.graphql": "0b14",
	"./AddStaffLevelWithExcelLite.graphql": "0889",
	"./AddUserDocuments.graphql": "f309",
	"./ArchiveEmployee.graphql": "7066",
	"./AutomationSwitch.graphql": "23b8",
	"./CancelLoan.graphql": "2464",
	"./CheckCompanyPhoneNumberExists.graphql": "7047",
	"./CheckEligibility.graphql": "cc07",
	"./CompanyAdminLogin copy.graphql": "4e90",
	"./CompanyAdminLogin.graphql": "b599",
	"./ConfirmOTP.graphql": "8a92",
	"./ConfirmPin.graphql": "7662",
	"./ConfirmRegistration.graphql": "1e53",
	"./CreateAccountInformation.graphql": "3a67",
	"./CreateAllowance.graphql": "57ed",
	"./CreateAuthenticatorSecret.graphql": "b2d6",
	"./CreateBackUpCodes.graphql": "f018",
	"./CreateBankAccount.graphql": "f01b",
	"./CreateBnDAndAddEmp.graphql": "2e44",
	"./CreateBonusOrDeduction.graphql": "b2e84",
	"./CreateBranch.graphql": "aabc",
	"./CreateCompany.graphql": "66c9",
	"./CreateCompanyAddressVerification.graphql": "4d1d",
	"./CreateCompanyDocuments.graphql": "b396",
	"./CreateCompanyExec.graphql": "813f",
	"./CreateCompanyInformation.graphql": "b614",
	"./CreateDepartment.graphql": "74b5",
	"./CreateEmployee.graphql": "cb7a",
	"./CreateLoan.graphql": "a644",
	"./CreatePayrollAutomation.graphql": "fd23",
	"./CreatePersonalInformation.graphql": "6648",
	"./CreateRoleV3.graphql": "cc7a",
	"./CreateValidIdentityInformation.graphql": "43b2",
	"./DeleteBankAccount.graphql": "51f0",
	"./DeleteBonusOrDeduction.graphql": "6d12",
	"./DeleteBranch.graphql": "0639",
	"./DeleteCompany.graphql": "a6fa",
	"./DeleteCompanyAsset.graphql": "c9db",
	"./DeleteCompanyExec.graphql": "3ef8",
	"./DeleteDeductions.graphql": "db1d",
	"./DeleteDeductionsMultiple.graphql": "c2a2",
	"./DeleteDepartment.graphql": "f72e",
	"./DeleteEducationAward.graphql": "9fe5",
	"./DeleteEducationCertificate.graphql": "c460",
	"./DeleteEducationHistory.graphql": "8d8e",
	"./DeleteEmployeeBonusOrDeductionV3.graphql": "201f",
	"./DeleteJobHistory.graphql": "eb27",
	"./DeletePayrollAutomation.graphql": "9a58",
	"./DeleteProrate.graphql": "7a70",
	"./DeleteUserDocument.graphql": "0f19",
	"./DisableTwoFa.graphql": "a504",
	"./EmployeeLogin.graphql": "9925",
	"./EnableNotifications.graphql": "a23e",
	"./EnableTwoFa.graphql": "a566",
	"./FetchLoanAmount.graphql": "549a",
	"./GenerateProductApiKeys.graphql": "f315",
	"./InviteDeveloper.graphql": "d728",
	"./LiteRegisterCompany.graphql": "2578",
	"./LogRegister.graphql": "941b",
	"./PaystackPaymentInit.graphql": "aaef",
	"./PreviewLoan.graphql": "10fa",
	"./ProcessPayroll.graphql": "503c",
	"./ProcessPayrollMultiple.graphql": "e1b0",
	"./Prorate.graphql": "3699",
	"./ReApplyLoan.graphql": "ebda",
	"./RePayLoan.graphql": "6091",
	"./RefreshToken.graphql": "df4e",
	"./RegisterEmployerPaye.graphql": "da32",
	"./RegisterItfCompliance.graphql": "e522",
	"./RegisterNhfCompliance.graphql": "3d95",
	"./RegisterNsitfCompliance.graphql": "48ca",
	"./RegisterPayeCompliance.graphql": "c1f71",
	"./RegisterPayeEmployee.graphql": "df1a",
	"./RegisterPensionCompliance.graphql": "44b2",
	"./RegisterPensionEmployee.graphql": "4f8d",
	"./RemoveEmployeeFromRoleV3.graphql": "31d8",
	"./RemoveFromTeam.graphql": "b0d8",
	"./ResetPassword.graphql": "c5bb",
	"./SaveURLVisit.graphql": "89d5",
	"./SelectCompany.graphql": "4220",
	"./SendEmail.graphql": "989c",
	"./SendLinkForEmployeeOnboarding.graphql": "1fc8",
	"./SendOTP.graphql": "794c",
	"./SendOtpForgotPassword.graphql": "c925",
	"./SendPaySlipEmails.graphql": "6f1f",
	"./SendPaySlipEmailsAll.graphql": "237e",
	"./SendPaymentLink.graphql": "7c77",
	"./SendPayslipZip.graphql": "13f1",
	"./SendSupportMessage.graphql": "a781",
	"./SendWalletReportEmail.graphql": "abb1",
	"./SubmitTaxForm.graphql": "558d",
	"./SubscribeV3.graphql": "3ff3",
	"./TalktoUs.graphql": "6463",
	"./UnarchiveEmployee.graphql": "1dba",
	"./UpdateAdminProfile.graphql": "8567",
	"./UpdateAward.graphql": "5d08",
	"./UpdateBankAccount.graphql": "5781",
	"./UpdateBonusOrDeduction.graphql": "986c",
	"./UpdateBranch.graphql": "e9f6",
	"./UpdateBusinessProfile.graphql": "cace",
	"./UpdateCompanyAsset.graphql": "ea3e",
	"./UpdateCompanyBankDetails.graphql": "cbb1",
	"./UpdateCompanyDocuments.graphql": "b3c0",
	"./UpdateCompanyExec.graphql": "edda",
	"./UpdateDeductions.graphql": "6902",
	"./UpdateDepartment.graphql": "a27c",
	"./UpdateEducationCertificate.graphql": "cb61",
	"./UpdateEducationHistory.graphql": "7c71",
	"./UpdateEmergencyContact.graphql": "6273",
	"./UpdateEmployeeBonusOrDeductionBulkV3.graphql": "ca9e",
	"./UpdateEmployeeBonusOrDeductionV3.graphql": "d6aa",
	"./UpdateEmployeeJob.graphql": "3637",
	"./UpdateEmployeePayment.graphql": "33f5",
	"./UpdateEmployeeProfile.graphql": "1c65",
	"./UpdateEmployeeProfileBulk.graphql": "d50d",
	"./UpdateEmployeeSection.graphql": "5876",
	"./UpdateFamily.graphql": "a5e9",
	"./UpdateHealth.graphql": "9018",
	"./UpdateJobHistory.graphql": "dfff",
	"./UpdatePassword.graphql": "8439",
	"./UpdatePayrollAutomation.graphql": "99f6",
	"./UpdatePersonalDocuments.graphql": "4060",
	"./UpdateProduct.graphql": "8d57a",
	"./UpdateProfile.graphql": "ccd6",
	"./UpdateRole.graphql": "ccec",
	"./UpdateStaffLevel.graphql": "0904",
	"./UpdateUserDocument.graphql": "cb07",
	"./UpdateUserPermissionSettings.graphql": "9172",
	"./VerifyAccountDetails.graphql": "9505",
	"./VerifyOtpForogotPassword.graphql": "f3d1",
	"./ViewBonusDeductionExcel.graphql": "c938",
	"./ViewEmployeeBnD.graphql": "c6ff",
	"./ViewStaffLevelWithExcelLite.graphql": "f124",
	"./Withdraw.graphql": "62e7",
	"./deleteAllowanceDetails.graphql": "6ea6",
	"./multipleSalaryUpdate.graphql": "e73b",
	"./updateAllowanceDetails.graphql": "3da9",
	"./updateAllowanceDetailsMultiple.graphql": "4d05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d76";